import React, { Component } from "react";
import swal from 'sweetalert';
import { toast } from "react-toastify";
import AddSharpIcon from '@material-ui/icons/AddSharp';
import SearchSharpIcon from '@material-ui/icons/SearchSharp';
import MoreVertSharpIcon from "@material-ui/icons/MoreVertSharp";
import { FormControl, Button, InputGroup, Table, Form, Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';

import axios from '../../../axios';
import apiError from '../../../error';
import { debounce, getCookie } from "../../../function";
// import AddUserModal from '../../../component/iam/add-user/add-user';
import CreateUsers from '../../../component/iam/users/create-users';
import './iamuser.css';
import Pagination from "react-js-pagination";


export default class Users extends Component {
    constructor(props) {
        super(props);
        this.isTAconnected = getCookie('isTAconnected');
        this.isTASyncing = getCookie('isTASyncing');
        this.state = {
            employees: [],
            show: false,
            search: '',
            limit: 10,
            count: 0,
            activePage: 1,
            editUserId: null
        }
        this.load();
    }

    handleModal = () => {
        this.setState(prevState => ({ show: !prevState.show }))
    }

    nextPath = path => this.props.history.push(path);
    componentDidUpdate(prevProps) {
        if (
            prevProps.search !== this.props.search ||
            prevProps.limit !== this.props.limit ||
            prevProps.roleFilterId !== this.props.roleFilterId ||
            prevProps.statusFilter !== this.props.statusFilter
        ) {
            this.setState({ activePage: 1 }, () => this.load());
        }
    }

    getPageLimit = () =>
        this.props.limit != null && this.props.limit !== "" ? this.props.limit : this.state.limit;

    load = debounce(() => {
        const params = {
            search: this.props.search,
            limit: this.getPageLimit(),
            page: this.state.activePage,
        };
        if (this.props.roleFilterId) {
            params.roleId = this.props.roleFilterId;
        }
        // Matches table: Verified = status active && valid === 1; Pending = otherwise
        if (this.props.statusFilter === "verified") {
            params.status = "active";
            params.valid = 1;
        } else if (this.props.statusFilter === "pending") {
            // Backend should return users where NOT (status === "active" && valid === 1)
            params.valid = 0;
        }
        axios.get('/api/iam-user/', {
            params,
        })
            .then(res => {
                this.setState({ employees: res.data.employees, count: res.data.count })
            })
            .catch(err => apiError(err))
    }, 500)


    handleEdit = (userId) => {
        this.setState({ editUserId: userId, show: true });
    }

    deleteUser = (userId) => {
        swal({
            title: "Do You Want To Delete User?",
            icon: "warning",
            buttons: ['No', 'Yes'],
        })
            .then(willSuccess => {
                if (willSuccess) {
                    axios.delete('/api/iam-user/delete/' + userId, {})
                        .then(res => {
                            toast.success("User Deleted Successfully");
                            this.load();
                        })
                        .catch(err => apiError(err))
                }
            });
    }
    handleRedirectToTAAddUser = async () => {
        try {
            const response = await axios.post('/api/redirect/', {
                urlName: "addIAMUser"
            });
            window.location.replace(`${response.data.url}?appName=TSAT&action=iam`);
        } catch (error) {
            apiError(error);
        }
    }

    render() {
        return (
            <>
                <div className="tableContainerWrapInner">
                    <Table responsive className="mb-0">
                        <thead className="bg-light">
                            <tr>
                                <th>IAM User</th>
                                <th>Role</th>
                                <th>Status</th>
                                {/* {this.isTAconnected && <th>Role</th>} */}
                                {!this.isTAconnected && <th>Action</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.employees.length > 0 ? this.state.employees.map((employee, index) => {
                                const roleName = employee.userPolicies.map(policy => policy.role?.name);
                                const isVerified = employee.status === "active" && employee.valid === 1;
                                return <tr key={index}>
                                    <td>
                                        <div className="user-cell">
                                            <div className="avatar">
                                                {employee?.firstname?.[0]}{employee?.lastname?.[0] ?? ""}
                                            </div>
                                            <div className="user-cell-content">
                                                <h6>{employee?.firstname} {employee?.lastname ?? ""}</h6>
                                                <p>{employee?.email}</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        {roleName.map(role => (
                                            <span key={role} className="badge badge-soft-secondary">{role}</span>
                                        ))}
                                    </td>
                                    <td>
                                        <span className={isVerified ? "badge badge-soft-success" : "badge badge-soft-warning"}>
                                            {isVerified ? "Verified" : "Pending"}
                                        </span>
                                    </td>
                                    {/* {this.isTAconnected && <td>{(employee?.userPolicies && employee.userPolicies.length > 0 && employee.userPolicies[0].role?.name) || "---"}</td>} */}
                                    {!this.isTAconnected &&
                                        <td>
                                            <Dropdown
                                                className="action-dropdown dropdownIcon" ref={this.selectRef}>
                                                <Dropdown.Toggle className="btn-only" id="dropdown-basic">
                                                    <MoreVertSharpIcon className="dot-icon"></MoreVertSharpIcon>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <Dropdown.Item onClick={()=>this.handleEdit(employee.id)}>Edit</Dropdown.Item>
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            this.isTASyncing ? (
                                                                <Tooltip id="top"> <span>Threatcop Admin Sync is already in progress</span>
                                                                </Tooltip>
                                                            ) : (
                                                                <Tooltip id="top" className="d-none" />
                                                            )
                                                        }
                                                    >
                                                        <Dropdown.Item className={`${this.isTASyncing && "disabledCls3"}`} onClick={e => { if (!this.isTASyncing) return this.deleteUser(employee.id) }} >Delete</Dropdown.Item>
                                                    </OverlayTrigger>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </td>
                                    }

                                </tr>
                            }) : <tr><td colSpan={4} className="text-center text-muted py-4">No user found</td></tr>}
                        </tbody>
                    </Table>
                    {this.state.employees.length > 0 &&
                        <div className="pagination-Wrap">
                            <div className="row">
                                <div className="col-md-6">
                                    <Pagination
                                        itemClass="page-item"
                                        linkClass="page-link"
                                        activePage={this.state.activePage}
                                        itemsCountPerPage={this.getPageLimit()}
                                        totalItemsCount={this.state.count}
                                        onChange={(pageNumber) => this.setState({ activePage: pageNumber }, () => this.load())}
                                    />
                                </div>
                                <div className="col-md-6 text-right d-flex align-items-center footer-pg">
                                    <div className="w-100 pgCount">
                                        <p>
                                            {this.state.count === 0
                                                ? 0
                                                : this.state.activePage * this.getPageLimit() + 1 - this.getPageLimit()}
                                            -
                                            {this.state.activePage * this.getPageLimit() > this.state.count
                                                ? this.state.count
                                                : this.state.activePage * this.getPageLimit()}{" "}
                                            of {this.state.count} records
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>


                {/* <AddUserModal
                        load={this.load}
                        show={this.state.show}
                        handleModal={this.handleModal}
                    ></AddUserModal> */}

                {/* <CreateUsers
                    // load={this.load}
                    show={this.props.createUsersShow}
                    handleModal={() => this.props.handleModal()}
                    createUsersShow={this.props.createUsersShow}
                /> */}

<CreateUsers
    show={this.props.createUsersShow || this.state.show}
    handleModal={() => {
        this.setState({ show: false, editUserId: null });
        this.props.handleModal();
        this.load();
    }}
    userId={this.state.editUserId}
    load={this.load}
/>



            </>
        );
    }
}